<template>
  <!-- Static header, with it's own shadow only shown if it's not overlaid by the scrolled header as to not double up the shadows -->
  <header-static v-if="!isLogsTab" :class="headerIsScrolled ? '' : 'shadow-xl'" />
  <header-scrolled :visible="headerIsScrolled && !isLogsTab">
    <div id="header-scrolled-target"></div>
  </header-scrolled>
  <div v-if="isLogsTab" class="h-2"></div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import HeaderScrolled from "./HeaderScrolled.vue";
import HeaderStatic from "./HeaderStatic.vue";
import useHeaderScrolled from "./scrolled";

const route = useRoute();
const currentTab = computed(() => route.params.tabSegments);
const isLogsTab = computed(() => currentTab.value[0] === "logs");
const headerIsScrolled = useHeaderScrolled();
</script>
